export default {
  "gatehouse": "Garita",
  "openControlPanel": "Abrir panel de control",
  "totalAccess": "Total de accesos",
  "deniedAccess": "Accesos denegados",
  "activeAlerts": "Alertas activas",
  "openIncidents": "Incidentes abiertos",
  "highRisk": "Riesgo alto",
  "accessLogHistory": "Historial de accesos",
  "refresh": "Actualizar",
  "export": "Exportar",
  "searchByMemberNameOrZone": "Buscar por nombre de socio o zona...",
  "status": "Estado",
  "allStatus": "Todos los estados",
  "granted": "Permitido",
  "denied": "Denegado",
  "zone": "Zona",
  "allZones": "Todas las zonas",
  "method": "Método",
  "allMethods": "Todos los métodos",
  "member": "Socio",
  "time": "Hora",
  "riskLevel": "Nivel de riesgo",
  "notes": "Notas",
  "noAccessLogsFoundMatchingYourCriteria": "No se han encontrado registros de acceso que coincidan con los criterios",
  "cameraEventTimeline": "Cronología de eventos de cámaras",
  "exportView": "Exportar vista",
  "searchByCameraName": "Buscar por nombre de cámara...",
  "eventType": "Tipo de evento",
  "allEventTypes": "Todos los tipos de evento",
  "person": "Persona",
  "vehicle": "Vehículo",
  "motion": "MOVIMIENTO",
  "doorbell": "Timbre",
  "loadingEvents": "Cargando eventos...",
  "noEventsFoundMatchingCriteria": "No se han encontrado eventos que coincidan con los criterios.",
  "eventThumbnail": "Miniatura del evento",
  "playback": "Reproducir grabación",
  "createIncident": "Crear incidente",
  "offline": "SIN CONEXIÓN",
  "loadingCameras": "Cargando cámaras...",
  "cameraWall": "Muro de cámaras",
  "grid": "Cuadrícula",
  "accessControlScanner": "Lector de control de acceso",
  "scanQrCodeRfidOrEnterMembershipNumber": "Escanee el código QR o RFID, o introduzca el número de socio...",
  "clear": "Limpiar",
  "staffOverride": "Autorización del personal",
  "gateCameras": "Cámaras de entrada",
  "recentGateActivity": "Actividad reciente en la entrada",
  "expectedArrivals": "Llegadas previstas",
  "noExpectedArrivalsToday": "No hay llegadas previstas para hoy",
  "quickActions": "Acciones rápidas",
  "reportIncident": "Notificar incidente",
  "viewLiveCameras": "Ver cámaras en directo",
  "emergencyOverride": "Autorización de emergencia",
  "incidentManagement": "Gestión de incidentes",
  "trackAndManageSecurityIncidentsAndReports": "Consulte y gestione los incidentes y los informes de seguridad",
  "searchIncidents": "Buscar incidentes...",
  "severity": "Gravedad",
  "allSeverity": "Todos los niveles de gravedad",
  "type": "Tipo",
  "allTypes": "Todos los tipos",
  "view": "Ver",
  "update": "Actualizar",
  "actionsTaken": "Medidas adoptadas:",
  "witnesses": "Testigos:",
  "followupRequired": "Requiere seguimiento",
  "noIncidentsFoundMatchingYourCriteria": "No se han encontrado incidentes que coincidan con los criterios",
  "incidentReportingFormWouldBeImplementedHere": "El formulario para notificar incidentes se implementaría aquí.",
  "close": "Cerrar",
  "securityAlerts": "Alertas de seguridad",
  "searchAlerts": "Buscar alertas...",
  "allRisk": "Todos los niveles de riesgo",
  "alertType": "Tipo de alerta",
  "acknowledge": "Acusar recibo",
  "resolve": "Resolver",
  "recommendedAction": "Medida recomendada:",
  "resolutionNotes": "Notas de resolución:",
  "noSecurityAlertsFoundMatchingYourCriteria": "No se han encontrado alertas de seguridad que coincidan con los criterios",
  "recentAccessActivity": "Actividad de acceso reciente",
  "prioritySecurityAlerts": "Alertas de seguridad prioritarias",
  "noHighpriorityAlerts": "No hay alertas prioritarias",
  "accessTrends7Days": "Tendencias de acceso (7 días)",
  "zoneAccessDistribution": "Distribución de accesos por zona",
  "alertRiskLevels": "Niveles de riesgo de las alertas",
  "zoneStatusOverview": "Resumen del estado de las zonas",
  "bookingRequired": "Reserva obligatoria",
  "unifiProtectIntegration": "Integración con UniFi Protect",
  "connected": "Conectado",
  "disconnected": "Desconectado",
  "totalCameras": "Total de cámaras",
  "online": "En línea",
  "recording": "Grabación:",
  "motionAlerts": "Alertas de movimiento",
  "cameraLocations": "Ubicaciones de cámaras",
  "fullscreen": "Pantalla completa",
  "cameraOffline": "Cámara sin conexión",
  "rec": "REC",
  "play": "Reproducir",
  "stop": "Detener",
  "model": "Modelo:",
  "ipAddress": "Dirección IP:",
  "nightVision": "Visión nocturna:",
  "selectACameraToViewLiveFeed": "Seleccione una cámara para ver la imagen en directo",
  "unifiIntegrationSettings": "Configuración de la integración con UniFi",
  "unifiConsoleIp": "IP de la consola UniFi",
  "username": "Nombre de usuario",
  "apiKey": "Clave de API",
  "testConnection": "Probar conexión",
  "saveSettings": "Guardar configuración",
  "zoneManagement": "Gestión de zonas",
  "configureAccessPermissionsAndSettingsForDifferentClubZones": "Configure los permisos de acceso y los ajustes de las distintas zonas del club",
  "addZone": "Añadir zona",
  "capacity": "Aforo",
  "hours": "Horario",
  "allowedMemberships": "Tipos de socio permitidos",
  "allMembers": "Todos los socios",
  "emergencyOverrideActive": "Autorización de emergencia activa",
  "active": "Activo",
  "edit": "Editar",
  "zoneConfigurationFormWouldBeImplementedHere": "El formulario de configuración de zonas se implementaría aquí",
  "inactive": "Inactivo",
  "enabled": "Activada",
  "disabled": "Desactivada",
  "editZone": "Editar zona",
  "addNewZone": "Añadir nueva zona",
  "editIncident": "Editar incidente",
  "reportNewIncident": "Notificar nuevo incidente",
  "scanning": "Escaneando...",
  "scan": "Escanear",
  "selectCamera": "Seleccionar cámara",
  "live": "EN DIRECTO",
  "unlimited": "Sin límite",
  "low": "Bajo",
  "medium": "Medio",
  "high": "Alto",
  "critical": "Crítico",
  "device": "Dispositivo: {id}",
  "anomaliesOne": "{count} anomalía",
  "anomaliesOther": "{count} anomalías",
  "accessSummary": "Se muestran {shown} de {total} registros de acceso",
  "alertsSummary": "Se muestran {shown} de {total} alertas",
  "incidentsSummary": "Se muestran {shown} de {total} incidentes",
  "grantedCount": "Permitidos: {count}",
  "deniedCount": "Denegados: {count}",
  "activeCount": "Activas: {count}",
  "acknowledgedCount": "Con acuse de recibo: {count}",
  "resolvedCount": "Resueltos: {count}",
  "openCount": "Abiertos: {count}",
  "investigatingCount": "En investigación: {count}",
  "confidence": "{count}% de confianza",
  "acknowledgedBy": "Acuse de recibo por {name}",
  "reportedBy": "Notificado por: {name}",
  "involves": "Persona implicada: {name}",
  "photosOne": "{count} foto adjunta",
  "photosOther": "{count} fotos adjuntas",
  "riskLabel": "Riesgo: {level}",
  "severityLabel": "Gravedad: {level}",
  "memberIdentity": "Socio de tipo {type}, n.º {number}",
  "visiting": "Visita a: {name}",
  "host": "Anfitrión: {name}",
  "expected": "Llegada prevista: {time}",
  "accessGranted": "Acceso permitido",
  "accessDenied": "Acceso denegado",
  "capacitySummary": "Aforo: {current}/{max}",
  "accessHours": "Acceso: {start} - {end}",
  "liveFeed": "Imagen en directo: {name}",
  "lastMotion": "Último movimiento: {time}",
  "validMembership": "Membresía válida",
  "inactiveMembership": "Membresía inactiva",
  "validVisitorPass": "Pase de visitante válido",
  "invalidVisitorPass": "Pase de visitante no válido",
  "invalidScanCode": "Código escaneado no válido",
  "systemError": "Error del sistema",
  "overrideApproved": "Autorización del personal aprobada",
  "loadError": "No se han podido cargar los datos de Seguridad. Inténtelo de nuevo.",
  "dateUnavailable": "Fecha no disponible",
  "noCameras": "No hay cámaras disponibles",
  "fullscreenCamera": "Ver cámara a pantalla completa",
  "pauseCamera": "Pausar vista en directo",
  "playCamera": "Reproducir vista en directo",
  "muteCamera": "Silenciar cámara",
  "unmuteCamera": "Activar sonido de la cámara",
  "eventDate": "Fecha del evento",
  "settings": "Configuración",
  "accessCount": "Número de accesos",
  "enums": {
    "status": {
      "granted": "permitido",
      "denied": "denegado",
      "active": "activo",
      "inactive": "inactivo",
      "acknowledged": "con acuse de recibo",
      "resolved": "resuelto",
      "dismissed": "descartado",
      "open": "abierto",
      "investigating": "en investigación",
      "closed": "cerrado",
      "online": "en línea",
      "offline": "sin conexión",
      "maintenance": "mantenimiento"
    },
    "risk": {
      "low": "bajo",
      "medium": "medio",
      "high": "alto",
      "critical": "crítico"
    },
    "severity": {
      "low": "baja",
      "medium": "media",
      "high": "alta",
      "critical": "crítica"
    },
    "method": {
      "qr_code": "código QR",
      "manual_override": "autorización manual",
      "rfid": "RFID"
    },
    "event": {
      "person": "persona",
      "vehicle": "vehículo",
      "motion": "movimiento",
      "doorbell": "timbre"
    }
  },
  "cameraIncidentDescription": "Incidente basado en la detección de {type} en {camera}."
};
